import React from 'react';
import moment from 'moment';

const Program = ({ program, index, isActiveDayToday, accessibility }) => {
  const activeAccessibilities = accessibility.filter(el => el.value);
  let highlighted = true;

  if (activeAccessibilities.length > 0) {
    try {
      highlighted = activeAccessibilities.some(a => {
        return program.events[0].access_services.tv[a.propertyName];
      });
    } catch (e) {
      highlighted = false;
    }
  }

  return (
    <div
      className={`tvg-text-view__program ${
        highlighted ? '' : 'tvg-text-view__program--hide'
      }`}
    >
      {isActiveDayToday && index == 0 && (
        <span className="tvg-text-view__program__indicator">On now</span>
      )}
      {isActiveDayToday && index == 1 && (
        <span className="tvg-text-view__program__indicator tvg-text-view--next-highlight">
          Next
        </span>
      )}
      <h3>
        <span dangerouslySetInnerHTML={{ __html: program.main_title }} />
        <span className="tvg-text-view__program__line-hidder" />
        <span className="tvg-text-view__program__start-time">
          {moment(program.start_time).format('h:mma')}
        </span>
      </h3>
      <span className="tvg-text-view__program__subtitle">
        {program.secondary_title && program.secondary_title}
        {program.events &&
          program.events[0] &&
          program.events[0].access_services &&
          program.events[0].access_services.tv &&
          program.events[0].access_services.tv.subtitles && (
            <i className="icon-access-subtitles" />
          )}
        {program.events &&
          program.events[0] &&
          program.events[0].access_services &&
          program.events[0].access_services.tv &&
          program.events[0].access_services.tv.signing && (
            <i className="icon-access-sign" />
          )}
        {program.events &&
          program.events[0] &&
          program.events[0].access_services &&
          program.events[0].access_services.tv &&
          program.events[0].access_services.tv.audio_description && (
            <i className="icon-access-ad" />
          )}
      </span>
      <p>
        {program.synopsis &&
          (program.synopsis.long ||
            program.synopsis.medium ||
            program.synopsis.short)}
      </p>
      {!program.parental_guidance && (
        <p>
          <i className="icon-parental-guidance" />
          This program is suitable for all ages.
        </p>
      )}
      {program.parental_guidance && (
        <p>{program.parental_guidance.explanatory_text}</p>
      )}
      <p>*Accessibility options might not be available on all devices</p>
    </div>
  );
};

export default Program;
